import { render } from "./MarketingMain.vue?vue&type=template&id=85108a4e&scoped=true"
import script from "./MarketingMain.vue?vue&type=script&lang=js"
export * from "./MarketingMain.vue?vue&type=script&lang=js"

import "./MarketingMain.vue?vue&type=style&index=0&id=85108a4e&scoped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85108a4e"]])

export default __exports__